import { LANGUAGE } from '../constants/localStorageKey';
import moment from 'moment-timezone';
import 'moment/min/locales.js';

// { language: momentLocale }
const momentLocaleMapping: Record<string, string> = {
  'zh-Hans': 'zh-cn',
  'pt': 'pt-br',
  'pt-PT': 'pt',
};

const getLanguage = () => {
  const language = localStorage.getItem(LANGUAGE) || 'en';
  return momentLocaleMapping[language] || language;
};

const DateUtils = {
  formatDate: (date?: string, format?: string) => {
    moment.locale(getLanguage());
    let stillUtc = moment.utc(date).toDate();
    return format ? moment(stillUtc).local().format(format) : moment(date).fromNow();
  },
  timeToXbyGMT: (startDate: any) => {
    moment.locale(getLanguage());
    const stillUtc = moment.utc(startDate).toDate();
    const localDate = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');
    return moment().to(localDate);
  },
  timetoXbyGMT: (startDate: any) => {
    moment.locale(getLanguage());
    let stillUtc = moment.utc(startDate).toDate();
    let localDate = moment(stillUtc)
      .local()
      .format('YYYY-MM-DD HH:mm:ss');
    return moment().to(localDate);
  },
  convertToGMTWithFormat: (startDate: any, dateFormat: string, timeZone: string) => moment.tz(startDate, dateFormat, timeZone).utc().format("YYYY-MM-DD HH:mm:ss"),
};

export default DateUtils;
